// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import queryString from 'query-string';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getInvoice = createAsyncThunk('invoicetSliceData/getInvoice', async (data) => {
    const query = queryString.stringify(data);

    try {
        let response = await axios.get('/Invoice?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getInvoicefilter = createAsyncThunk('invoicetSliceData/getInvoicefilter', async (data) => {
    const query = queryString.stringify(data);

    try {
        let response = await axios.get('/Invoice?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getInvoiceArchive = createAsyncThunk('invoicetSliceData/getInvoiceArchive', async (data) => {
    const query = queryString.stringify(data);
    try {
        let response = await axios.get('/Invoice?InvPaymentStatus=0&' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getInvoiceArchivefilter = createAsyncThunk('invoicetSliceData/getInvoiceArchivefilter', async (data) => {
    const query = queryString.stringify(data);
    try {
        let response = await axios.get('/Invoice?InvPaymentStatus=0&' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getInvoiceNo = createAsyncThunk('invoicetSliceData/getInvoiceNo', async (id) => {
    try {
        let response = await axios.get('/Invoice/invoice-number?companyId='+id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getInvoicenbyid = createAsyncThunk('invoicetSliceData/getInvoicenbyid', async (id) => {
    try {
        let response = await axios.get('/Invoice/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getPaymenthistorybyid = createAsyncThunk('invoicetSliceData/getPaymenthistorybyid', async (id) => {
    try {
        let response = await axios.get('/Invoice/payment-history/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createInvoice = createAsyncThunk('invoicetSliceData/createInvoice', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/Invoice', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Invoice added succesfully.');
        await dispatch(getInvoice());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const deleteInvoice = createAsyncThunk('invoicetSliceData/deleteInvoice', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/Invoice/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Invoice deleted successfully.');
        await dispatch(getInvoice());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const updatePayment = createAsyncThunk('invoicetSliceData/updatePayment', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Invoice/add-payment/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Payment Update succesfully.');
        // await dispatch(getInvoicenbyid(data?.id));

        // await dispatch(getInvoicenbyid(data?.id));
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const updateInvoice = createAsyncThunk('invoicetSliceData/updateInvoice', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Invoice/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Invoice Update succesfully.');
        await dispatch(getInvoice());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const updateAcknowledgeStatus = createAsyncThunk('invoicetSliceData/updateAcknowledgeStatus', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Invoice/update-ack-status/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Acknowledge Status Update succesfully.');
        await dispatch(getInvoice());
        await dispatch(getInvoiceArchive());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateFinalInvoice = createAsyncThunk('invoicetSliceData/updateFinalInvoice', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Invoice/upload-final-invoice/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        toast.success(response?.data?.message || 'Final Invoice updated succesfully.');
        await dispatch(getInvoice());
        await dispatch(getInvoiceArchive());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const invoiceslice = createSlice({
    name: 'invoicetSliceData',
    initialState: {
        invoice: [],
        invoiceFilter: [],
        paymenthistory: [],
        archiveInvoice: [],
        archiveInvoiceFilter: []
    },
    reducers: {
        removePendinginvoice: (state) => {
            state.invoice = [];
        },
        removeArchiveinvoice: (state) => {
            state.archiveInvoice = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInvoice.fulfilled, (state, action) => {
            state.invoice = action?.payload;
            return;
        });
        builder.addCase(getInvoicefilter.fulfilled, (state, action) => {
            state.invoiceFilter = action?.payload;
            return;
        });
        builder.addCase(getInvoiceArchive.fulfilled, (state, action) => {
            state.archiveInvoice = action?.payload;
            return;
        });
        builder.addCase(getInvoiceArchivefilter.fulfilled, (state, action) => {
            state.archiveInvoiceFilter = action?.payload;
            return;
        });
        builder.addCase(getPaymenthistorybyid.fulfilled, (state, action) => {
            state.paymenthistory = action?.payload;
            return;
        });
        // builder.addCase(getDayAdjustmentStatus.fulfilled, (state, action) => {
        //     state.dayAdjustmentStatus = action?.payload;
        //     return;
        // });
    }
});

export default invoiceslice.reducer;
export const { removePendinginvoice, removeArchiveinvoice } = invoiceslice.actions;
